import { render, staticRenderFns } from "./CompanySettingView.vue?vue&type=template&id=0232b503"
import script from "./CompanySettingView.vue?vue&type=script&lang=js"
export * from "./CompanySettingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports